(() => {
  const root = document.querySelector('[data-brine-site]');
  if (!root) return;

  const menu = root.querySelector('[data-mobile-menu]');
  root.querySelector('[data-menu-open]')?.addEventListener('click', () => {
    menu?.classList.add('is-open');
    menu?.setAttribute('aria-hidden', 'false');
  });
  root.querySelector('[data-menu-close]')?.addEventListener('click', () => {
    menu?.classList.remove('is-open');
    menu?.setAttribute('aria-hidden', 'true');
  });
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
  }));

  const heroSlides = [...root.querySelectorAll('[data-hero-slide]')];
  let heroIndex = 0;
  const showHero = (next) => {
    if (!heroSlides.length) return;
    heroIndex = (next + heroSlides.length) % heroSlides.length;
    heroSlides.forEach((slide, index) => { slide.hidden = index !== heroIndex; });
  };
  root.querySelector('[data-hero-prev]')?.addEventListener('click', () => showHero(heroIndex - 1));
  root.querySelector('[data-hero-next]')?.addEventListener('click', () => showHero(heroIndex + 1));
  showHero(0);

  const rail = root.querySelector('[data-category-rail]');
  root.querySelector('[data-rail-prev]')?.addEventListener('click', () => rail?.scrollBy({ left: -440, behavior: 'smooth' }));
  root.querySelector('[data-rail-next]')?.addEventListener('click', () => rail?.scrollBy({ left: 440, behavior: 'smooth' }));

  const featuredSelect = root.querySelector('[data-featured-select]');
  const featuredImage = root.querySelector('[data-featured-image]');
  const featuredColor = root.querySelectorAll('[data-featured-color]');
  const featuredSize = root.querySelector('[data-featured-size]');
  const featuredLink = root.querySelector('[data-featured-link]');
  const updateFeatured = () => {
    const option = featuredSelect?.selectedOptions?.[0];
    if (!option) return;
    if (featuredImage && option.dataset.image) {
      featuredImage.src = option.dataset.image;
      featuredImage.alt = option.dataset.title || option.textContent;
    }
    featuredColor.forEach((node) => { node.textContent = option.dataset.color || 'Selected'; });
    if (featuredSize) featuredSize.textContent = option.dataset.size || option.textContent;
    if (featuredLink) featuredLink.href = option.dataset.url || featuredLink.href;
  };
  featuredSelect?.addEventListener('change', updateFeatured);
  updateFeatured();

  const caseGallery = root.querySelector('[data-case-gallery]');
  const caseSlides = [...root.querySelectorAll('[data-case-slide]')];
  let caseIndex = 0;
  let caseTimer;
  const showCase = (next) => {
    if (!caseSlides.length) return;
    caseIndex = (next + caseSlides.length) % caseSlides.length;
    caseSlides.forEach((slide, index) => {
      const active = index === caseIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    const counter = root.querySelector('[data-case-count]');
    if (counter) counter.textContent = `${caseIndex + 1} / ${caseSlides.length}`;
  };
  const restartCases = () => {
    window.clearInterval(caseTimer);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      caseTimer = window.setInterval(() => showCase(caseIndex + 1), 4800);
    }
  };
  root.querySelector('[data-case-prev]')?.addEventListener('click', () => { showCase(caseIndex - 1); restartCases(); });
  root.querySelector('[data-case-next]')?.addEventListener('click', () => { showCase(caseIndex + 1); restartCases(); });
  caseGallery?.addEventListener('mouseenter', () => window.clearInterval(caseTimer));
  caseGallery?.addEventListener('mouseleave', restartCases);
  caseGallery?.addEventListener('focusin', () => window.clearInterval(caseTimer));
  caseGallery?.addEventListener('focusout', restartCases);
  showCase(0);
  restartCases();

  const categorySelect = root.querySelector('[data-catalog-category]');
  const sortSelect = root.querySelector('[data-catalog-sort]');
  const catalogGrid = root.querySelector('[data-catalog-grid]');
  const catalogCount = root.querySelector('[data-catalog-count]');
  const catalogCards = [...root.querySelectorAll('[data-catalog-card]')];
  const refreshCatalog = () => {
    if (!catalogGrid) return;
    const category = categorySelect?.value || 'All categories';
    const sort = sortSelect?.value || 'category-asc';
    const visible = catalogCards.filter((card) => category === 'All categories' || card.dataset.category === category);
    const direction = sort.endsWith('desc') ? -1 : 1;
    visible.sort((a, b) => {
      if (sort.startsWith('category')) return (a.dataset.category || '').localeCompare(b.dataset.category || '') * direction || (a.dataset.title || '').localeCompare(b.dataset.title || '');
      if (sort.startsWith('price')) return (Number(a.dataset.price) - Number(b.dataset.price)) * direction;
      return (Number(a.dataset.date) - Number(b.dataset.date)) * direction;
    });
    catalogCards.forEach((card) => { card.hidden = !visible.includes(card); });
    visible.forEach((card) => catalogGrid.appendChild(card));
    if (catalogCount) catalogCount.textContent = `${visible.length} PRODUCTS`;
  };
  categorySelect?.addEventListener('change', refreshCatalog);
  sortSelect?.addEventListener('change', refreshCatalog);
  root.querySelectorAll('[data-category-target]').forEach((button) => button.addEventListener('click', () => {
    if (categorySelect) categorySelect.value = button.dataset.categoryTarget;
    refreshCatalog();
    root.querySelector('#catalog')?.scrollIntoView({ behavior: 'smooth' });
  }));
  refreshCatalog();

  const reviews = [...root.querySelectorAll('[data-review]')];
  let reviewIndex = 0;
  const showReview = (next) => {
    if (!reviews.length) return;
    reviewIndex = (next + reviews.length) % reviews.length;
    reviews.forEach((review, index) => { review.hidden = index !== reviewIndex; });
    const counter = root.querySelector('[data-review-count]');
    if (counter) counter.textContent = `${reviewIndex + 1} / ${reviews.length}`;
  };
  root.querySelector('[data-review-prev]')?.addEventListener('click', () => showReview(reviewIndex - 1));
  root.querySelector('[data-review-next]')?.addEventListener('click', () => showReview(reviewIndex + 1));
  showReview(0);
})();
